<script lang="ts">
	import BaseNode from './BaseNode.svelte';
	import type { FlowNodePort } from '../helpers/flowBranchHandleStyles';
	import type { NodeData } from '../types/flow-types';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: cases = (Array.isArray(data.cases) ? data.cases : []) as Array<Record<string, unknown>>;
	$: variableName = String(data.variableName || '');
	$: inputPorts = [{ id: 'input', color: '#38bdf8' }] satisfies FlowNodePort[];
	$: outputPorts = [
		...cases.map((_, index) => ({
			id: `case-${index}`,
			color: COLORS[index % COLORS.length],
			alignSelector: `[data-variable-port="case-${index}"]`,
		})),
		{ id: 'default', color: '#94a3b8', alignSelector: '[data-variable-port="default"]' },
	] satisfies FlowNodePort[];
	const COLORS = ['#38bdf8', '#a78bfa', '#f59e0b', '#f472b6', '#34d399'];
	const symbols: Record<string, string> = { eq: '=', ne: '≠', gt: '>', ge: '≥', lt: '<', le: '≤' };
</script>

<BaseNode
	{id}
	type="variableSwitch"
	{data}
	{selected}
	validated={validated && Boolean(variableName) && cases.length > 0}
	{errors}
	{inputPorts}
	{outputPorts}
	cardTitle={variableName ? `Switch on ${variableName}` : 'Choose a variable'}
	nodeTypeLabel="Variable switch"
	avatarOverride={{ icon: 'fa-solid fa-code-branch', backgroundColor: 'color-base' }}
	{...$$restProps}
>
	<div class="case-list">
		{#each cases as item, index (item.id || index)}
			<div
				class="case-row"
				data-variable-port={`case-${index}`}
				style={`--case-color:${COLORS[index % COLORS.length]}`}
			>
				<span>{index + 1}</span>
				<div>{item.label || `Case ${index + 1}`}</div>
				<strong>{symbols[String(item.operator)] || item.operator} {item.value || '?'}</strong>
			</div>
		{/each}
		<div class="default-row" data-variable-port="default">
			<i class="fa-solid fa-ellipsis"></i> Default
		</div>
	</div>
</BaseNode>

<style>
	.case-list {
		display: flex;
		min-width: 14rem;
		flex-direction: column;
		gap: 0.25rem;
	}
	.case-row {
		display: grid;
		grid-template-columns: 1.25rem minmax(0, 1fr) auto;
		align-items: center;
		gap: 0.35rem;
		border-left: 3px solid var(--case-color);
		border-radius: 0.35rem;
		padding: 0.28rem 0.5rem;
		background: color-mix(in srgb, var(--case-color) 9%, transparent);
		font-size: 0.72rem;
	}
	.case-row span {
		color: var(--case-color);
		font-weight: 800;
	}
	.case-row div {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.case-row strong {
		font-weight: 650;
	}
	.default-row {
		display: flex;
		align-items: center;
		gap: 0.4rem;
		padding: 0.2rem 0.5rem;
		color: var(--flow-slot-muted);
		font-size: 0.72rem;
	}
</style>
